import Slider from 'react-slick';   
import  './DigitalClaims.css';

const PrevArrow = (props) => (
    <button {...props} className="slick-prev">
      <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
    </button>
  );
  
  const NextArrow = (props) => (
    <button {...props} className="slick-next">
      <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
    </button>
  );


const DigitalClaims = ()=>{

// START cards
  // const cards = [
  //   { 
  //     id: 1, 
  //     span: '01', 
  //     heading: 'Real-Time Claim Submission', 
  //     text: 'File claims instantly through our user-friendly portal.' },
  //   { 
  //     id: 2, 
  //     span: '02', 
  //     heading: 'Digital Document Upload', 
  //     text: 'Easily upload all your necessary photos and documentation.' },
  //   { 
  //     id: 3, 
  //     span: '03', 
  //     heading: 'Automated Status Updates', 
  //     text: 'Stay informed with real-time notifications on claim progress.' },
  //   { 
  //     id: 4, 
  //     span: '04', 
  //     heading: 'Adjuster Communication', 
  //     text: 'Communicate directly for quicker resolutions.' },
  //   { 
  //     id: 5, 
  //     span: '05', 
  //     heading: 'Integrated Repair Network', 
  //     text: 'Access our network of trusted repair facilities.' },
  //   { 
  //     id: 6, 
  //     span: '06', 
  //     heading: 'Express Payment and Collections', 
  //     text: 'Speed up financial transactions to minimize downtime.' },
  //   { 
  //     id: 7, 
  //     span: '07', 
  //     heading: 'Comprehensive Claim History', 
  //     text: 'Maintain organized records for future reference.' },
  //  ];
// END cards

// START slick
    const settings = {
        slidesToShow: 6,
        slidesToScroll: 1,
        margin: 30,
        autoplay: true,
        autoplaySpeed: 2500,

        // autoplaySpeed: 0,  // No delay between scrolls
        // speed: 4000,  // Smooth continuous movement
        // cssEase: 'linear',

        loop: true,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        centerPadding: '30px',
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
          {
            breakpoint: 1480,
            settings: {
              slidesToShow: 5, // Correcting the key to 'slidesToShow'
              infinite: false,
              centerPadding: "30px",
              margin: 30,
            },
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4, // Correcting the key to 'slidesToShow'
              infinite: false,
              centerPadding: "30px",
              margin: 30,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4, // Correcting the key to 'slidesToShow'
              infinite: false,
              margin: 30,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3, // Correcting the key to 'slidesToShow'
              margin: 20,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2, // Correcting the key to 'slidesToShow'
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2, // Correcting the key to 'slidesToShow'
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 2, // Correcting the key to 'slidesToShow'
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1, // Correcting the key to 'slidesToShow'
              centerPadding: "30px",
            },
          },
        ],
      };
// END slick

    return(
        <>
        <section className='digitalClaimsMain' id='DigitalClaimsManagement'>
         <div className='container'>
              <div className='row justify-content-center'>
                  <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      <div className='digitalClaimsHead'>
                          <h2>Digital <span>Claims Management</span></h2>
                      </div>
                    </div>
              </div>


              <div className='simplifiedDigital'>
                  <div className='row justify-content-center align-items-center'>
                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                            <div className='digitalClaimsLeft'>
                                <img src="/img/rentshield/DigitalClaimsInner.webp" alt="Digital Claims"/>
                            </div>
                        </div>
                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                          <div className='digitalClaimsRight'>
                              <h3>Simplified Digital Claims Processing</h3>
                              <p>Experience hassle-free claims management with our intuitive <span>Resolution Center</span></p>
                              <img src="/img/rentshield/power_success.svg" alt="Simplified Digital Claims Processing"/>
                          </div>
                        </div>
                  </div>
              </div>
          </div>
 
          <div className='row justify-content-center'>
                <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                    <Slider {...settings} className="claimsProcessingOuter">  
                        <div className="item">
                            <div className="claimsDetail">
                                <span>01</span>
                                <h3>Real-Time Claim Submission</h3>
                                <p>File claims instantly through our user-friendly portal.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="claimsDetail">
                                <span>02</span>
                                <h3>Digital Document Upload</h3>
                                <p>Easily upload all your necessary photos and documentation.</p>
                            </div>
                        </div> 
 
                        <div className="item">
                            <div className="claimsDetail">
                                <span>03</span>
                                <h3>Automated Status Updates</h3>
                                <p>Stay informed with real-time notifications on claim progress.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="claimsDetail">
                                <span>04</span>
                                <h3>Adjuster  Communication</h3>
                                <p>Communicate directly for quicker resolutions.</p>
                            </div>
                        </div> 
 
                        <div className="item">
                            <div className="claimsDetail">
                                <span>05</span>
                                <h3>Integrated Repair Network</h3>
                                <p>Access our network of trusted repair facilities.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="claimsDetail">
                                <span>06</span>
                                <h3>Express Payment and Collections</h3>
                                <p>Speed up financial transactions to minimize downtime.</p>
                            </div>
                        </div> 
                        <div className="item">
                            <div className="claimsDetail">
                                <span>07</span>
                                <h3>Comprehensive Claim History</h3>
                                <p>Maintain organized records for future reference.</p>
                            </div>
                        </div> 
                    </Slider> 
  
                </div>
          </div>  


          {/* <div className="shieldSlider">
            <div className="carousel-container mt-2">
              <div className="carousel">
              <div className="carousel-track ">
                {cards.map((card) => (
                  <div key={card.id} className=" claimsDetail">
                    <span>{card.span}</span>
                    <h3>{card.heading}</h3>
                    <p>{card.text}</p>
                  </div>
                ))}
                  </div>
                
                <div className="carousel-track ">
                {cards.map((card) => (
                  <div key={`duplicate-${card.id}`} className=" claimsDetail">
                    <span>{card.span}</span>
                    <h3>{card.heading}</h3>
                    <p>{card.text}</p>
                  </div>
                ))}
              </div>
              </div>
            </div>
          </div> */}

              
        </section>
        </>
    )
}

export default DigitalClaims;